import { negotiate } from "./negotiate/negotiate";
import { qualifications } from "./qualification/qualifications";
import { resources } from "./resource/resource";
import { relationshipTypes } from "./relationshipTypes/relationshipTypes";

export const resourceService = {
  resources,
  negotiate,
  qualifications,
  relationshipTypes,
};
